__turbopack_context__.v({
  "product-badge": "izQ39a_product-badge",
  "product-badge-caption": "izQ39a_product-badge-caption",
  "product-custom-text": "izQ39a_product-custom-text",
  "product-details": "izQ39a_product-details",
  "product-img": "izQ39a_product-img",
  "product-name": "izQ39a_product-name",
  "product-price": "izQ39a_product-price",
  "product-wrapper": "izQ39a_product-wrapper",
  "productimg-secondary": "izQ39a_productimg-secondary",
});
